import type { StateCreator } from 'zustand';

import type { CreditInfo } from '@/types/monetization';
import type { UserSlice } from './types';

export type { UserSlice } from './types';

export const userInitialState = {
  areCreditsAvailable: null as boolean | null,
  creditsInfo: null as Partial<CreditInfo> | null,
};

export const createUserSlice: StateCreator<UserSlice, [], [], UserSlice> = (
  set
) => ({
  ...userInitialState,

  setAreCreditsAvailable: (areCreditsAvailable) => set({ areCreditsAvailable }),
});
